let version: string | null = null;

export async function loadVersion(): Promise<string> {
  if (version) return version;

  const versionUrl = `/version.txt?v=${Date.now()}`;
  const response = await fetch(versionUrl, { cache: 'no-store' });
  version = await response.text();
  version = version.trim(); // remove trailing newline if any

  return version;
}
